module.exports = __webpack_public_path__ + "img/sxp.bfa67282.png";